import { MicroControllerType } from '../../microcontroller/microcontroller';
export const getBoardType = (): MicroControllerType => {
    return MicroControllerType.ARDUINO_UNO;
};